export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_flowInstanceNo') || '流程编号',
    field: 'flowInstanceNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_flowInstanceTitle') || '流程标题',
    field: 'flowInstanceTitle',
    minWidth: 280,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_taskTitle') || '任务标题',
    field: 'title',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_businessNo') || '单据编号',
    field: 'businessNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayApplicant') || '申请人',
    field: 'displayApplicant',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayApplicant' },
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
